// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B4Wv","fullView":"styles_fullView__1E515"};